module.exports = __webpack_public_path__ + "static/media/2017_conf_Product_Lifecycle.504b0a0c.jpg";